import { NOTICE_WITH_OUT_AUTH_SUCCESS } from "../../../Constant/Notice/Notice/NoticeWithOutAuthConstant";

export const getNoticeWithOutAuthByTypeIdReducer = (state = { noticeWithOutAuthByTypeId: [] }, action) => {
  switch (action.type) {
    case NOTICE_WITH_OUT_AUTH_SUCCESS:
      return {
        ...state,
        loading: false,
        noticeWithOutAuthByTypeId: action.payload,
      };

    default:
      return state;
  }
};
